'use client'

import { generalOptions } from "@/lib/renderContent";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { LayoutFAQs } from "trimble-terra"
import "./SectionFaqs.css"

const FormatSectionFaqs = ( data: any, draftEnabled: boolean,  ) => {

  const formattedFaqItems = data?.data?.faqItemsCollection?.items?.map((faq: any) => {
    return {
      headline: faq?.question,
      description: faq?.answer?.json
        ? documentToReactComponents(faq.answer.json, generalOptions)
        : '',
    };
  });

  const formattedFaqData = {
    faqType: "t2-collapsed",
    isHeaderBig: false,
    faqItems: formattedFaqItems,
  };

  return (
    <div className="mx-auto faqs-section pb-10">
      <LayoutFAQs {...formattedFaqData} isWrapped={true} />
    </div>
  );
}
export default FormatSectionFaqs;
